/* Moved from snippets/hlth-reveal.liquid so browsers cache it (speed audit item 6, 16 Oct 2026); loaded async where the
   inline script was. */
  /* HLTH scroll reveal: [data-animate] fades up as it scrolls into view; the [data-animate]
     children of [data-animate-stagger] follow each other 0.1 s apart.

     Only elements that start below the first screen are hidden, and only here, once the page
     is parsed: the first screen never animates, CSS hides nothing, and the page reads in full
     if this script never runs. A hidden element is shown the moment any part of it is in view
     (IntersectionObserver), so nothing can stay stuck at opacity 0. Reduced motion: nothing
     is hidden. Replaced the GSAP version and its 1.5 s CSS fallback and 2 s force-reveal
     (speed audit, 15 Oct 2026). */
  (function () {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var EASE = 'cubic-bezier(0.215, 0.61, 0.355, 1)';
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        io.unobserve(entry.target);
        var group = entry.target.__hlthReveal || [entry.target];
        group.forEach(function (el, i) { show(el, i * 0.1); });
      });
    }, { rootMargin: '0px 0px -10% 0px' });

    function hide(el) {
      el.style.opacity = '0';
      el.style.translate = '0 30px';
    }

    function show(el, delay) {
      el.style.transition = 'opacity 0.6s ' + EASE + ' ' + delay + 's, translate 0.6s ' + EASE + ' ' + delay + 's';
      requestAnimationFrame(function () {
        el.style.opacity = '';
        el.style.translate = '';
        setTimeout(function () { el.style.transition = ''; }, (0.7 + delay) * 1000);
      });
    }

    /* Below the first screen, and not off to the side in a swipe carousel (the observer never
       sees those cross the screen vertically, so they would wait for a swipe). */
    function belowFirstScreen(el) {
      var r = el.getBoundingClientRect();
      return r.top >= window.innerHeight && r.left < window.innerWidth && r.right > 0;
    }

    function init(root) {
      var claimed = [];
      root.querySelectorAll('[data-animate-stagger]').forEach(function (parent) {
        if (parent.dataset.revealInit) return;
        parent.dataset.revealInit = '1';
        var kids = Array.prototype.slice.call(parent.querySelectorAll('[data-animate]'));
        claimed = claimed.concat(kids);
        /* Marked as the group's, so the DOMContentLoaded pass leaves them to it; without this that pass took each
           one on its own and they all rose at once, losing the 0.1 s steps (found 22 Oct 2026, 1.9.1). */
        kids.forEach(function (kid) { kid.dataset.revealInit = '1'; });
        if (!kids.length || !belowFirstScreen(parent)) return;
        kids.forEach(hide);
        parent.__hlthReveal = kids;
        io.observe(parent);
      });
      root.querySelectorAll('[data-animate]').forEach(function (el) {
        if (el.dataset.revealInit || claimed.indexOf(el) !== -1) return;
        el.dataset.revealInit = '1';
        if (!belowFirstScreen(el)) return;
        hide(el);
        io.observe(el);
      });
    }

    /* Rendered at the end of <body>, so the sections are parsed: start now rather than wait for
       DOMContentLoaded behind the deferred scripts; the second pass catches anything added later. */
    init(document);
    document.addEventListener('DOMContentLoaded', function () { init(document); });

    /* Theme editor: sections added or reloaded */
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();
